var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"li-embed-wrap"},[(_vm.embedSrc)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","position":"absolute","inset":"0","border":"0"},attrs:{"src":_vm.embedSrc,"allowfullscreen":"","frameborder":"0","scrolling":"no","title":"LinkedIn post"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }